<template>
   <div class="outer-container">
    <div class="inner-container">
    <div>
      <h1>Compound Interest Calculator</h1>
      <h2>Unleash the Magic of Compound Interest: RiskyPaws's Guide to Turning Pennies into Fortunes!</h2>
      <br><p>Alright, future moguls, listen up! Compound Interest is your BFF—Best Financial Friend. 🤑 Invest early and even the smallest sum can turn into a 
        mountain of gold! Why? Because your money earns interest, and then that interest earns more interest! It's a never-ending loop of growing wealth! 🔄<br><br>
        🕰️ Time is money, literally. The longer you let your investment sit and purr, the fatter it gets. So, don't be a scaredy-cat—invest now and let the magic 
        of compounding do its thing! It's fun and interactive just like your cat's favourite wind-up mouse so try some numbers and see what incredible returns the power of compounding can bring. <br><br>
        📊 Graphs Freak You Out?: "No worries! Keep scrolling for a cute plant analogy that'll make compounding as clear as a litter box freshly scooped! 🌱
    </p>
    <iframe height="600" class="calculator" style="width: 100%;" scrolling="no" title="The Power of Compounding Interest" src="https://codepen.io/Farah-Kamal/embed/jOdGZvz?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
</iframe>
      <iframe height="600" class="flower" style="width: 100%;" scrolling="no" title="Compound Interest" src="https://codepen.io/Farah-Kamal/embed/KKbjmoX/e389f2d969388b2761592b8e92b1d84d?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
</iframe>
    </div></div></div><br><br><br><br><br><br>
  </template>
  <script setup>
  
  </script>
  <style scoped>
  



.outer-container {
  background-color: #4A148C; 
  padding: 5px;
  border-radius: 10px;
}

.inner-container {
  background-color: #ffffff; 
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  margin: 10px;
}
.iframe-container {
  overflow-x: auto; /* Enable horizontal scrolling on small screens */
}


@media (max-width: 768px) { /* Adjusts for devices with width up to 768px */
  .calculator {
    height: 1200px !important; /* Sets the height of iframes with class 'calculator' */
  }
}

.flower{
    height: 650px !important; /* Sets the height of iframes with class 'calculator' */
  }

</style>